/**
 * Main Entry Point
 *
 * React application bootstrap with Web Vitals monitoring and i18n.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { logWebVitals } from './utils/webVitals';
import './i18n'; // Initialize i18n before rendering
import './index.css';

// Initialize Web Vitals logging in development
logWebVitals();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
